module.exports = "<div class=\"{{ vm.name }}\">\n<!--[if lt IE 10]>\n<div class=\"st-disclaimer\" role=\"alert\" type=\"info\">\n   <span class=\"st-disclaimer__text\">  \n       {{ 'user_outdated_browser' | translate}}\n       {{ 'browser_upgrade_recommended' | translate}}\n    </span>\n</div>\n<![endif]-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/stBrowserAlerts/stBrowserAlerts.html
// module id = 45
// module chunks = 0